import { useContext } from 'react';
import { AppContext } from '../../context/AppContext';
import Resource from '../modal/Resource';
import { AssignmentOutlined } from '@mui/icons-material';

function Header() {
	const {
		resourceOpen,
		setNoticeOpen,
		setResourceOpen,
		setCentralityIndexOpen,
	} = useContext(AppContext);

	const onClickRefresh = () => {
		window.location.reload();
	};

	return (
		<div className="header">
			<a href="../../../interactive" className="logo">
				KRIHS 인터랙티브 리포트
			</a>
			<button type="button" className="headerTit" onClick={onClickRefresh}>
				유입·유출 중심성 지수로 알아보는 우리 지역 거점
			</button>

			<div className="headerBtn">
				<button onClick={() => setNoticeOpen(true)}>
					<img src="img/headerIcon01.png" alt="icon" />
					기획의도
				</button>
				<button onClick={() => setCentralityIndexOpen(true)}>
					<AssignmentOutlined
						fontSize="large"
						style={{ marginRight: '0.4rem' }}
					/>
					중심성 지수
				</button>
				<button onClick={() => setResourceOpen(true)}>
					<img src="img/headerIcon02.png" alt="icon" />
					데이터 출처
				</button>
			</div>
			{resourceOpen ? <Resource /> : null}
		</div>
	);
}

export default Header;
